import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { generateClient } from 'aws-amplify/api';
import { getCharacter } from '../graphql/queries';
import { updateCharacter } from '../graphql/mutations';
import './EditCharacter.css';

const client = generateClient();

const EditCharacter = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [character, setCharacter] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCharacter();
  }, [id]);

  async function fetchCharacter() {
    try {
      setLoading(true);
      const characterData = await client.graphql({
        query: getCharacter,
        variables: { id }
      });
      setCharacter(characterData.data.getCharacter);
    } catch (err) {
      console.error('Error fetching character:', err);
      setError('Failed to load character. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCharacter({ ...character, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await client.graphql({
        query: updateCharacter,
        variables: { input: character }
      });
      navigate('/characters');
    } catch (err) {
      console.error('Error updating character:', err);
      setError('Failed to update character. Please try again.');
    }
  };

  if (loading) return <div className="edit-character__loading">Loading character data...</div>;
  if (error) return <div className="edit-character__error">{error}</div>;
  if (!character) return <div className="edit-character__not-found">Character not found</div>;

  return (
    <div className="edit-character">
      <h1 className="edit-character__title">Edit {character.name}</h1>
      <form onSubmit={handleSubmit} className="edit-character__form">
        <div className="edit-character__field">
          <label htmlFor="name" className="edit-character__label">Name:</label>
          <input
            type="text"
            id="name"
            name="name"
            value={character.name}
            onChange={handleInputChange}
            className="edit-character__input"
            required
          />
        </div>
        <div className="edit-character__field">
          <label htmlFor="race" className="edit-character__label">Race:</label>
          <input
            type="text"
            id="race"
            name="race"
            value={character.race}
            onChange={handleInputChange}
            className="edit-character__input"
            required
          />
        </div>
        <div className="edit-character__field">
          <label htmlFor="characterClass" className="edit-character__label">Class:</label>
          <input
            type="text"
            id="characterClass"
            name="characterClass"
            value={character.characterClass}
            onChange={handleInputChange}
            className="edit-character__input"
            required
          />
        </div>
        {/* Add more fields as needed */}
        <button type="submit" className="edit-character__submit">Save Changes</button>
      </form>
    </div>
  );
};

export default EditCharacter;
